module.exports = function (app) {
    app.controller('pages.employer.reports', ["$state", "$scope", "sessionData", "services", "invisibleFormService", "employerUtility", "$window","modal", "coremetrics",
            function ($state, $scope, sessionData, services, invisibleFormService, employerUtility, $window, modal, coremetrics) {

                $scope.feedback = {};
                $scope.clientNo = sessionData && sessionData.employerInfo && sessionData.employerInfo.planAdministrator && sessionData.employerInfo.planAdministrator.clientNumber ? sessionData.employerInfo.planAdministrator.clientNumber : '';
                if ((sessionData.entitlements.clientStatus.cancelled == true)
                    && (!sessionData.cancelledClientHasAgreed)) {
                    $state.go('cancelledConditions');
                }
                console.log(sessionData)
                $scope.loginId=sessionData &&sessionData.employerInfo&&sessionData.employerInfo.planAdministrator?sessionData.employerInfo.planAdministrator.loginId:"";
                $scope.bpdId=sessionData &&sessionData.employerInfo&&sessionData.employerInfo.planAdministrator?sessionData.employerInfo.planAdministrator.dataDifferentiator:""
                $scope.aso="false";
                if(sessionData &&sessionData.entitlements&&sessionData.entitlements.clientQualifiers&&sessionData.entitlements.clientQualifiers.aso){
                    $scope.aso="true"; 
                }
                $scope.medeData=sessionData && sessionData.employerInfo && sessionData.employerInfo.planAdministrator && sessionData.employerInfo.planAdministratorEntitlements?sessionData.employerInfo.planAdministratorEntitlements.userLevelEntitlements['Mede Analytics']:false;
				var entitlements = sessionData.entitlements;
                var envSplit = location.host.split("."); // tenv3.highmarkbcbs.com
                var env = envSplit[0].substring(1);
                //console.log("Env "+env);
                console.log("Mede data flag "+$scope.medeData)
                //EHN 1934 - we are making medeanalytics as false
            
				$scope.enableMedeAnalytics = $scope.medeData;
                console.log("enableMedeAnalytics "+$scope.enableMedeAnalytics)
                
				$scope.enableReportsAtHand = entitlements.reports.atHand;
				$scope.enableEnrollmentReports = entitlements.reports.enrollment;
                var groupAccess = sessionData.employerInfo.planAdministratorEntitlements.groupLevelEntitlements;
                $scope.showSSN = false;
                $scope.enableCensusReports = entitlements.reports.CensusReports;
                $scope.enableWellnessReports = entitlements.reports.WellnessReports;
                $scope.errormessage = false;
                $scope.successmessage = false;
                $scope.reportLoading = false;
                $scope.isND = sessionData.employerInfo.brandName === '6011';
                $scope.options = [
                    {
                        name: 'Excel',
                        value: 'Excel'
                    },
                    {
                        name: 'PDF',
                        value: 'PDF'
                    }
                ];
                $scope.selectedOption = $scope.options[0];


				loadReports();



                // Sidebar
                $scope.$parent.sidebar = {
                    breadCrumb: {
                        primary: {
                            title: "Reports"
                        }
                    }
                };
                $scope.reports = {
                    orderBy: 'reportType',
                    reverse: true,
                    pagination: {
                        itemsPerPage: 10,
                        page: 1
                    },
                    titles: [
                        {
                            name: "Report Type",
                            dataKey: "reportType",
                            selectAll: true
                        },
                        {
                            name: "Tax Year",
                            dataKey: "taxYear"
                        },
                        {
                            name: "Last Run Date",
                            dataKey: "lastRunDate"
                        },
                        {
                            name: "File Type",
                            dataKey: "fileType"
                        }
                    ],
                    mobileTitles: [
                        {
                            name: "Report Type",
                            dataKey: "reportType"
                        },
                        {
                            name: "Tax Year",
                            dataKey: "taxYear"
                        },
                        {
                            name: "Last Run Date",
                            dataKey: "lastRunDateMobile"
                        },
                        {
                            name: "File Type",
                            dataKey: "fileType"
                        }
                    ],
                    rows: []
                };
                $scope.status = {
                    getEnrollmentReports: false
                };

                function loadReports() {
                    if ($scope.enableEnrollmentReports) {
                        $scope.reportsServiceIsRunning = true;
                        services.eprsvc.enrollmentReports().getReports($scope.clientNo).then(
                            function (response) {
                                // comment to make it build
                                $scope.reportsServiceIsRunning = false;
                                var reports = response.data.payload;
                                for (var i = 0; i < reports.length; i++) {
                                    reports[i].lastRunDate = new Date(reports[i].lastRunDate);
                                    reports[i].lastRunDateMobile = reports[i].lastRunDate.toDateString();
                                    if (reports[i].reportFile && reports[i].reportFile.length>0) {
                                        var theButton = {
                                            type: "aButton",
                                            theLabel: 'Download'
                                        }
                                        reports[i].controlsInRow = [];
                                        reports[i].controlsInRow.push(theButton);
                                    }
                                }
                                $scope.reports.rows = reports;
                                $scope.status.getEnrollmentReports = true;
                                $scope.reportsFound = true;
                            },
                            function (error) {
									console.debug('error in loadReports', error);
                                $scope.reportsServiceIsRunning = false;
                                $scope.status.getEnrollmentReports = false; //true; // true here AND in success function?
                                if (error.data.baseMessage && error.data.baseMessage.returnCode === 100212) {
                                	if (!(entitlements.reports.medeAnalytics || entitlements.reports.atHand)) {
                                        $scope.feedback.showFeedback("Enrollment reports are currently not available at this time.", "notification");
									}
                                    $scope.reportsFound = false;
                                } else {
                                    employerUtility.handleError($scope.reportFlashes, error);
                                }
                            }
						);
					}
				};

                $scope.downloadReport = function (fileName) {
                    coremetrics.elementTag('DOWNLOAD ENROLLMENT REPORTS', 'EMPLOYERS:REPORTS:LANDING PAGE');
                    invisibleFormService.submit(
                        {
                            name: 'downloadReport',
                            method: 'GET',
                            action: '/eprsvc/x-services/secure/reports/v1/download/enrollment/' + fileName,
                            target: '_self',
                            inputs: {
                                clientNumber: $scope.clientNo
                            }
                        }
                    ); };
                $scope.performSSO = function () {
                    // coremetrics.elementTag('CLICK MEDEANALYTICS', 'EMPLOYERS:REPORTS:LANDING PAGE');
                    
                    // services.eprsvc.vendorSSO().getSSOParams('medeAnalytics').then(
                    //     function (success) {
                    //         var ssoURL = success.data.payload.ssoUrl;
                    //         var urlAppend = (ssoURL.indexOf("?") > -1) ? "&" : "?";
                    //         var sitePrmotionTag = "cm_sp=Health%20Analytics-_-MedeAnalytics-_-MedeAnalytics";
                    //         var theUrl = ssoURL + urlAppend + sitePrmotionTag;
                    //         var ssoFormConfig = {
                    //             "name": "InvisibleSsoSvcsFormName",
                    //             "id": "InvisibleSsoSvcsFormId",
                    //             "formTarget": "InvisibleSsoSvcs",
                    //             "method": "POST",
                    //             "action": theUrl,
                    //             "target": "_self",
                    //             "inputs": {}
                    //         };
                    //         var formParams = success.data.payload.ssoFormParams;
                    //         for (var i = 0; i < formParams.length; i++) {
                    //             ssoFormConfig.inputs[formParams[i].name] = formParams[i].value;
                    //         }
                    //         // next line sends the user where they should go
                    //         invisibleFormService.submit(ssoFormConfig);
                    //         console.log(success);
                    //     },
                    //     function (error) {
					// 		console.debug('error', c);
					// 		if (error && error.data && error.data.baseMessage && error.data.baseMessage.returnCode == 100212) {
					// 			$scope.reportsFound = false;
					// 		}
					// 		else {
					// 			employerUtility.handleError($scope.reportFlashes, error);
					// 		}
                    //     }
                    // );

                    //New Mede changes
                    services.eprsvc.vendorSSO().medeUpdate($scope.loginId,$scope.bpdId,$scope.aso).then(
                        function(success)
                        {
                            if(success.data.status=="true"){
                            if(env!="ww"){
                                if($scope.bpdId==='16'){
                                    window.open("https://cdssotest.bcbsndportals.com/oamfed/idp/initiatesso?providerid=ND/my.medeanalytics.com",'_blank','noopener,noreferrer');
                                }else{
                                    window.open("https://cdssotest.highmark.com/oamfed/idp/initiatesso?providerid=https://my.medeanalytics.com");
                                }
                            }else{
                                if($scope.bpdId==='16'){
                                    window.open("https://cdsso.bcbsndportals.com/oamfed/idp/initiatesso?providerid=ND/my.medeanalytics.com",'_blank','noopener,noreferrer');
                                }else{
                                    window.open("https://cdsso.highmark.com/oamfed/idp/initiatesso?providerid=https://my.medeanalytics.com");
                                }
                            }
                        }else{
                            console.log("error",success.data.message);
                        }
                        },function (error) {
                            
                            console.log("error",error)
                        }
                        )
                };

                $scope.goToReportsAtHand = function () {
                    coremetrics.elementTag('CLICK REPORTSATHAND', 'EMPLOYERS:REPORTS:LANDING PAGE');
                    var sitePromotionTag = "?cm_sp=Reports%20at%20Hand-_-Reports%20at%20Hand-_-Reports%20at%20Hand";
                    $window.open("/cfsreq/index.jsp" + sitePromotionTag, "_blank");

                }

                $scope.click = function (action, row) {
                    if (action === 'download') {
                        $scope.downloadReport(row.reportFile);
                    }
                };
                $scope.groupTableObj = {

                    order: 'groupNumber',
                    reverse: true,
                    selectAllRows: false,
                    rowSelectionEnabled: true,

                    titles: [
                        {
                            name: 'Group Number',
                            dataKey: 'groupNumber'
                        }

                    ],
                    pagination: {
                        itemsPerPage: 12,
                        page: 1
                    },


                    groupAccessArray : []
                };

                if (groupAccess) {
                    for (var grp in groupAccess) {
                        if (groupAccess.hasOwnProperty(grp)) {
                            var group = {};
                            var current = groupAccess[grp];
                            group.groupNumber = grp;
                            group.selected = false;

                            if ((current['Employee Data'] === 'View' || current['Employee Data'] === 'Modify')) {
                                $scope.groupTableObj.groupAccessArray.push(group);
                            }
                        }
                    }

                }
                $scope.$on("update_parent_controller", function(event, message,selectall){
                    $scope.message = message;
                    $scope.selectAll = selectall;
                });

                $scope.openSuccessModal = function() {
                    if($scope.message) {
                        $scope.$broadcast('recieving from reports', $scope.message, $scope.selectAll);
                    }


                    modal.open({
                                   heading: 'Select Specific Groups for Census Report',
                                   template: require('modals/censusReportSelection.html'),
                                   controller: require("../../modals/censusReportSelection"),
                                   scope: $scope,
                                   classes: 'selected-groups-modal census-large-modal'

                               });

                };




                $scope.onGenerate = function(){
                    $scope.reportLoading = true;
                    var groupsSelected ;
                    if($scope.message && $scope.message.length > 0){
                        groupsSelected = $scope.message.toString();
                    }
                    else {
                        var fromGroupArray = [];
                        for(var indx = 0;indx<$scope.groupTableObj.groupAccessArray.length;indx++) {
                            fromGroupArray.push($scope.groupTableObj.groupAccessArray[indx].groupNumber);
                        }

                        groupsSelected = fromGroupArray.toString();
                    }
                    var params = {
                        reportFormat:$scope.selectedOption.value,
                        ssnMask:$scope.showSSN === true? 'N' : 'Y',
                        groupNumbersList:groupsSelected
                    }


                    services.eprsvc.censusReport().runCensusReport(params). then(
                        function (response) {
                            $scope.reportLoading = false;
                            if($scope.errormessage){
                                $scope.errormessage = false;
                            }

                            $scope.reports = response.data.payload;
                            $scope.successmessage = true;

                        }, function (error) {
                            $scope.reportLoading = false;
                            if($scope.successmessage){
                                $scope.successmessage = false;
                            }
                            $scope.errormessage = true;
                            console.log("error", error);
                        });




                };

                $scope.resetCensus = function () {
                    $scope.message = [];
                    $scope.selectedOption = $scope.options[0];
                    $scope.selectAll = false;
                    $scope.errormessage = false;
                    $scope.successmessage = false;
                    $scope.showSSN = false;

                };



            }
        ]
    );

    return [
        {
            state: "reports",
            url: "/reports",
            postPassword: true,
            views: {
                'body@': {
                    template: bootstrap.templates['page-templates/hmhs/landing-page.html']

                },
                "dashboard@reports": {
                    templateUrl: "reports.employerTemplate.html/pages/reports/reports",
                    controller: "pages.employer.reports"
                }
            }
        }
    ];
};
